/* ----------------------------------
Import modules
---------------------------------- */

import PageFiltersController from "scripts/marmalade/classes/page-filters";
import RangeSliderController from "scripts/marmalade/classes/range-slider";

/* ----------------------------------
Variables
---------------------------------- */

// Find the page
const page = document.querySelector('.js-research-papers');
// Find the search list
const list = page.querySelector('.js-research-papers__list');
// Find the search form
const form = page.querySelector('.js-research-papers__form');
// Find the search results
const results = page.querySelector('.js-research-papers__results');
// Find the download button
const download = page.querySelector('.js-research-papers__download');
// Find the count
const count = page.querySelector('.js-research-papers__count');
// Find the sort inputs
const sort = [...page.querySelectorAll('[name="sort"]')];
// The pagination selector
const paginationSelector = '.js-pagination a';
// An object to hold the date range inputs
const dateRange = {
  min: form.querySelector('[name="from"]'),
  max: form.querySelector('[name="to"]')
};

// Create a new RangeSliderController
const RangeSlider = new RangeSliderController(dateRange.min, dateRange.max);
// Create a new FilterController
const PageFilters = new PageFiltersController(form, {
  hardFilters: ['limit', 'sort']
});

/* ----------------------------------
Functions
---------------------------------- */

const addNewInputs = () => {
  // Find the limit element
  const limit = page.querySelector('.js-pagination__limit');

  // If there is a limit
  if (limit) {
    // If a limit is set in the filter, set the limit control to that value
    if (PageFilters.value[limit.name]) {
      limit.value = PageFilters.value[limit.name][0];
    }

    // When the limit is changed, update the filter
    limit.addEventListener('change', () => {
      PageFilters.set(limit.name, limit.value);
      // Update the page
      PageFilters.submit();
    });

    // // Check if the window.SimpleSelectors[limit.id].default.select is in the page
    // if (!limit.SimpleSelector) {
    //   // Set up a new simple selector for the limit control
    //   window.SimpleSelectors[limit.id] = new SimpleSelectorController(limit);
    // }
  }
};
const updateCount = () => {
  // If there is no count element, do nothing
  if (!count) return;

  // The last element in the results will have a data-results attribute, so find that
  const data = results.querySelector('[data-results]');

  // If there is no data attribute, do nothing
  if (!data) return;

  // Parse the data attribute
  const numberOfPapers = parseInt(data.getAttribute('data-results'));
  count.innerHTML = numberOfPapers + ' result' + (numberOfPapers === 1 ? '' : 's');

  // If count is 0, disable the download button
  download.classList.toggle('disabled', numberOfPapers === 0);
};
const updateDownloadLink = () => {
  // If there is no download link, do nothing
  if (!download) return;

  // We need to grab the href from the link, and then add all the filter parameters to it
  const downloadURL = download.getAttribute('href');
  // get just the direct link with no query string
  const downloadPath = downloadURL.split('?')[0];
  // Grab the value from the PageFilters in a new object
  const filterValue = Object.assign({}, PageFilters.value);

  // Remove the page parameter from the filter
  delete filterValue.page;
  // Remove the limit parameter from the filter
  delete filterValue.limit;

  // Convert the filter value object to a query string
  const filterQuery = new URLSearchParams(filterValue).toString();

  // Set the download link
  download.href = downloadPath + '?' + filterQuery;
};

/* ----------------------------------
Document setup
---------------------------------- */

// Set the date range container
dateRange.min.parentElement.appendChild(RangeSlider.render());

// When the form is submitted
PageFilters.on('submit', () => {
  // Add a loading class to the list
  list.classList.add('loading');
  // Smooth scroll the page to the top of the results
  // window.ScrollController.scrollTo(Meteora.offset(results).y - 200, 500);
});
PageFilters.on('change', () => {
  // Update the download link
  updateDownloadLink();
});

// When the filter is applied and loads successfully
PageFilters.on('success', response => {
  // Set the results
  results.innerHTML = response;
});
PageFilters.on('complete', () => {
  // Set up the pagination
  PageFilters.paginate([...page.querySelectorAll(paginationSelector)]);

  // Limit the page length
  addNewInputs();
  // Update the count
  updateCount();
});
PageFilters.on('pageChanged', () => {
  window.ScrollController.scrollTo(Meteora.offset(results).y - 200, 500);
});

// When the filter is applied but there is an error
PageFilters.on('error', response => {
  // Tell the user there was an error
  console.warn('There was an error loading the results. Error code:', response);
  results.innerHTML = `<tr><td colspan="3"><p class="null">There was an error loading the results.</p></td></tr>`;
});

// When the page filters have completed
PageFilters.on('complete', () => {
  // Remove the loading classes
  results.classList.remove('loading');
  results.classList.remove('loading-inner');
  // Remove the page parameter from the filter
  PageFilters.remove('page');
  list.classList.remove('loading');
});

// When the page filters have been grabbed from the URL
PageFilters.on('getURLFilters', () => {
  console.log('getURLFilters');
  updateDownloadLink();
});

// Set up the pagination
PageFilters.paginate([...page.querySelectorAll(paginationSelector)]);

// Loop through the sort inputs
sort.forEach(input => {
  if (input.type === 'radio') {
    // If a sort is set in the filter, select the correct input
    if (PageFilters.value[input.name]) {
      input.checked = PageFilters.value[input.name][0] === input.value;
    }

    // When the sort is changed, update the filter
    input.addEventListener('change', () => {
      // If the input is checked
      if (input.checked) {
        PageFilters.set(input.name, input.value);
        // Update the page
        PageFilters.submit();
      }
    });
  } else {
    // If we are here the input is a select
    // If a sort is set in the filter, select the correct input
    if (PageFilters.value[input.name]) {
      input.value = PageFilters.value[input.name];
    }

    // When the sort is changed, update the filter
    input.addEventListener('change', () => {
      PageFilters.set(input.name, input.value);
      // Update the page
      PageFilters.submit();
    });
  }
});

// Limit the page length
addNewInputs();